
import { useCallback } from "react";
import { useToast } from "@/hooks/use-toast";

export const useFormValidation = (
  name: string, 
  currentStock: number, 
  usageRate: number
) => {
  const { toast } = useToast();

  const validateForm = useCallback(() => {
    if (!name.trim()) {
      toast({
        title: "Name required",
        description: "Please enter a name for the product",
        variant: "destructive",
      });
      return false;
    }

    if (currentStock < 0) {
      toast({
        title: "Invalid stock",
        description: "Current stock cannot be negative",
        variant: "destructive",
      });
      return false;
    }

    if (usageRate <= 0) {
      toast({
        title: "Invalid usage rate",
        description: "Usage rate must be greater than zero",
        variant: "destructive",
      });
      return false;
    }

    return true;
  }, [name, currentStock, usageRate, toast]);

  return { validateForm };
};
